import React from 'react';
import PropTypes from 'prop-types';
import cuid from 'cuid';
import { css } from 'react-emotion';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  wide: PropTypes.bool,
  reversed: PropTypes.bool,
};

const defaultProps = {
  reversed: false,
  disabled: false,
};

const disabledClass = css`
  opacity: 0.5;
  cursor: not-allowed;
  .slider,
  .slider::before {
    cursor: not-allowed;
  }
`;

const background = css`
  background-color: #0000001a;
`;

class Switch extends React.PureComponent {
  constructor() {
    super();
    this.id = cuid();
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange({ target }) {
    const { onChange, disabled, reversed } = this.props;
    if(disabled === true) return;
    onChange({ [target.name]: reversed ? !target.checked : target.checked });
  }

  render() {
    const { onChange, label, value, disabled, wide, reversed, ...rest } = this.props;
    const wrapperClass = disabled === true ? disabledClass : '';
    const layoutClass = wide ? "r-switch" : "t-switch";
    const labelContent = typeof label === 'object' ? label : <span className="switch-label">{label}</span>;
    return (
      <div className={`${wrapperClass} ${layoutClass}`}>
        {labelContent}
        <label className="switch" htmlFor={this.id}>
          <input type="checkbox" id={this.id} onChange={this.handleChange} checked={reversed ? !value : value} {...rest} />
          <div className={`slider round ${background}`} />
        </label>
      </div>
    );
  }
}

Switch.propTypes = propTypes;
Switch.defaultProps = defaultProps;
export default Switch;


// WEBPACK FOOTER //
// ./src/components/form/Switch.jsx